import React, { useState } from 'react';
import { MemoryRouter as Router, Switch, Route } from "react-router-dom";
import Header from './components/js/header';
import Home from './components/js/home';
import LineCard from './components/js/linecard';
import Distributors from './components/js/distributors';
import ContactUs from './components/js/contactus';
import Products from './components/js/products';

import 'bootstrap/dist/css/bootstrap.min.css';
import './components/scss/global.scss';
import './components/scss/app.scss';

function App() {
  const [ showProducts ] = useState(false);
  const [ showLineCards ] = useState(true);
  const [ showDistributors ] = useState(false);
  const [ showContactUs ] = useState(true);

  var visablePages = {
    products: showProducts,
    linecards: showLineCards,
    distributors: showDistributors,
    contactus: showContactUs
  }

  return (
    <Router>
      <div className="main-container">
        <nav className="header-container">
          <Header visablePages={visablePages}/>
        </nav>

        <div className="body-container">
          <Switch>
            <Route path="/linecard">
              <LineCard />
            </Route>
            <Route path="/distributors">
              <Distributors />
            </Route>
            <Route path="/contactus">
              <ContactUs />
            </Route>
            <Route path="/products">
              <Products />
            </Route>
            <Route path="/">
              <Home visablePages={visablePages}/>
            </Route>
          </Switch>
        </div>
        <footer className="footer-container">
          <p className="copyright-text">
            © Copyrighted 1985-2018 Electra Technical Sales, All Rights Reserved
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
